import { format } from "date-fns";

export function dateFormatDateMinuteHour(date: Date) {
  return format(new Date(date), "yyyy-MM-dd hh:ss");
}

export function dateFormat(date: Date) {
  return format(new Date(date), "yyyy-MM-dd");
}
